export default "__VITE_ASSET__BRq1jHAh__"